__turbopack_context__.v({
  "button": "gift-product-card-module-scss-module__aEU7Tq__button",
  "giftCard": "gift-product-card-module-scss-module__aEU7Tq__giftCard",
  "giftName": "gift-product-card-module-scss-module__aEU7Tq__giftName",
});
